import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, catchError, firstValueFrom, of, tap } from 'rxjs';
import { IAppConfig } from '../shared/interfaces/app-config';

@Injectable({
  providedIn: 'root',
})
export class AppConfigService {
  config: IAppConfig;
  public configStatus = new BehaviorSubject<boolean>(false);

  constructor(private httpClient: HttpClient) {
  }

  public loadConfig(): Observable<any> {
    if (this.config) return of(null);
    return this.httpClient.get<any>('./assets/config/config.json').pipe(
      tap((config: any) => {
        this.config = config;
        this.configStatus.next(true);
      }),
      catchError((err: any) => {
        this.configStatus.next(false);
        return of({});
      }));
  }

  public getConfig(): any {
    return this.config;
  }
}
